import React, { Component } from 'react';
import{
    Container,
    Row,
    Col,
    Input,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Button,
    Label
} from 'reactstrap';
/**
 * Used for the Listino Prezzi section. 
 */
export class UtentiData extends Component {

    constructor(props) {
        super(props);

        this.toggleRuoli = this.toggleRuoli.bind(this);
        this.toggleAgenti = this.toggleAgenti.bind(this);

        this.state = {
            editPassword: false,
            ruoliOpen: false,     
            agentiOpen: false,
        };
    
    }

    changeEditPassword = (e) => {
        this.setState({
            editPassword: !this.state.editPassword
        })
    }

    toggleRuoli = () => {
        this.setState({
            ruoliOpen: !this.state.ruoliOpen
        })
    }

    toggleAgenti = () => {
        this.setState({
            agentiOpen: !this.state.agentiOpen
        })
    }
    /**
     * Renders the page
     */
    render() {
        return (
            <Container fluid style={{color: "#011e41"}}> 
                    <Container>
                        <Row>
                            <Col className="d-flex align-items-center justify-content-start">
                                <h3 style={{color: "#011e41", fontWeight: "bold", fontSize:"35px", margin: "0px"}}>Informazione:</h3>
                            </Col>
                        </Row>
                        <Row style={{marginBottom: "5px", height: "90%"}}>
                            <Col sm={3} className="d-flex align-items-center justify-content-start">
                                <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Nome Utente:</h4>                                                    
                            </Col>
                            <Col sm={6} className="d-flex align-items-center justify-content-start">
                                <Input id="userName" name="userName" type="text" autoComplete="new-userName" onChange={this.props.handleFilterChange} value={this.props.userName} style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                            </Col>
                        </Row>
                        <Row style={{marginBottom: "5px", height: "90%"}}>
                            <Col sm={3} className="d-flex align-items-center justify-content-start">
                                <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Email:</h4>                                                    
                            </Col>
                            <Col sm={6} className="d-flex align-items-center justify-content-start">
                                <Input id="email" name="email" type="email" onChange={this.props.handleFilterChange} value={this.props.email} autoComplete="new-email" style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                            </Col>
                        </Row>
                        <Row style={{marginBottom: "5px", height: "90%"}}>
                            <Col sm={3} className="d-flex align-items-center justify-content-start">
                                <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Nome:</h4>                                                    
                            </Col>
                            <Col sm={6} className="d-flex align-items-center justify-content-start">
                                <Input id="nome" name="nome" type="text" onChange={this.props.handleFilterChange} value={this.props.nome} autoComplete="new-nome" style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                            </Col>
                        </Row>
                        <Row style={{marginBottom: "5px", height: "90%"}}>
                            <Col sm={3} className="d-flex align-items-center justify-content-start">
                                <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Cognome:</h4>                                                    
                            </Col>
                            <Col sm={6} className="d-flex align-items-center justify-content-start">
                                <Input id="cognome" name="cognome" type="text" autoComplete="new-cognome" onChange={this.props.handleFilterChange} value={this.props.cognome} style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                            </Col>
                        </Row>
                        {this.props.edit ?
                            <Row style={{marginBottom: "5px", height: "90%"}}>
                                <Col className="d-flex align-items-center justify-content-start">                       
                                    <Label style={{marginLeft: "31.25px"}}>
                                        <Input type="checkbox" id="checkbox2" onClick={this.changeEditPassword} value={this.state.editPassword}/>{' '}
                                            modifica la password
                                    </Label>                                          
                                </Col>                    
                            </Row> : null
                        }
                        {!this.props.edit || this.state.editPassword ?
                            <Container fluid style={{margin: "0", padding: "0"}}>
                                <Row style={{marginBottom: "5px", height: "90%"}}>
                                    <Col sm={3} className="d-flex align-items-center justify-content-start">
                                        <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Password:</h4>                                                    
                                    </Col>
                                    <Col sm={6} className="d-flex align-items-center justify-content-start">
                                        <Input id="password" name="password" type="password" autoComplete="new-password" onChange={this.props.handleFilterChange} value={this.props.password} style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                                    </Col>
                                </Row>
                                <Row style={{marginBottom: "5px", height: "90%"}}>
                                    <Col sm={3} className="d-flex align-items-center justify-content-start">
                                        <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Verifica la Password:</h4>                                                    
                                    </Col>
                                    <Col sm={6} className="d-flex align-items-center justify-content-start">
                                        <Input id="verificaPassword" name="verificaPassword" type="password" onChange={this.props.handleFilterChange} value={this.props.verificaPassword} style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                                    </Col>
                                </Row>
                            </Container> : null
                        }
                        
                        {this.props.roles ?
                            <Row style={{marginBottom: "5px", height: "90%"}}>
                                <Col sm={3} className="d-flex align-items-center justify-content-start">
                                    <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Ruolo:</h4>                                                    
                                </Col>
                                <Col sm={6} className="d-flex align-items-center justify-content-start">
                                    <Dropdown isOpen={this.state.ruoliOpen} toggle={this.toggleRuoli}>
                                        <DropdownToggle style={{backgroundColor: "#011e41"}} caret>
                                            {this.props.selectedRole}
                                        </DropdownToggle>
                                        <DropdownMenu
                                            modifiers={{
                                                setMaxHeight: {
                                                    enabled: true,
                                                    order: 890,
                                                    fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                        ...data.styles,
                                                        overflow: 'auto',
                                                        maxHeight: "50vh",
                                                        color: "#011e41"
                                                        },
                                                    };
                                                    },
                                                },
                                                computeStyle: {
                                                    gpuAcceleration: false
                                                }}}>
                                            <Container>
                                                {this.props.roles.map(role => {
                                                    return (<DropdownItem key={role.id} id={role.id} onClick={() => this.props.handleRoleSelect(role)}>{role.normalizedName}</DropdownItem>)
                                                })}
                                            </Container>
                                        </DropdownMenu>
                                    </Dropdown> 
                                </Col>
                            </Row> : null
                        }
                        
                        {this.props.selectedRole === "Agenti" ? 
                            <Row style={{marginBottom: "5px", height: "90%"}}>
                                <Col sm={3} className="d-flex align-items-center justify-content-start">
                                    <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>agenteId:</h4>                                                    
                                </Col>
                                <Col sm={6} className="d-flex align-items-center justify-content-start">
                                    <Dropdown isOpen={this.state.agentiOpen} toggle={this.toggleAgenti}>
                                        <DropdownToggle style={{backgroundColor: "#011e41"}} caret>
                                            {this.props.agenteId}
                                        </DropdownToggle>
                                        <DropdownMenu
                                            modifiers={{
                                                setMaxHeight: {
                                                    enabled: true,
                                                    order: 890,
                                                    fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                        ...data.styles,
                                                        overflow: 'auto',
                                                        maxHeight: "50vh",
                                                        color: "#011e41"
                                                        },
                                                    };
                                                    },
                                                },
                                                computeStyle: {
                                                    gpuAcceleration: false
                                                }}}>
                                            <Container>
                                                {this.props.agenti.map(agente => {
                                                    return (<DropdownItem key={agente.codice} id={agente.codice} onClick={() => this.props.handleAgenteSelect(agente)}>{agente.nominativo}</DropdownItem>)
                                                })}
                                            </Container>
                                        </DropdownMenu>
                                    </Dropdown>
                                </Col>
                            </Row> : null
                        }
                        {this.props.error ? 
                            <Row style={{marginBottom: "5px", height: "90%"}}>
                                <Col className="d-flex align-items-center justify-content-center" style={{color: "red"}}>
                                    {this.props.error}                                          
                                </Col>
                            </Row> : null
                        }
                        <Row style={{marginBottom: "5px", height: "90%"}}>
                            <Col className="d-flex align-items-center justify-content-center">
                                <Button className="text-center" style={{width: '30%', padding: '0px', backgroundColor: "#011e41"}} onClick={this.props.submitForm}>
                                    {this.props.edit ? "Aggiorni" : "Inserisci"}
                                </Button>                                             
                            </Col>
                        </Row>
                    </Container>
                
            </Container>                                              
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Utenti/UtentiData.js